module.exports = __webpack_public_path__ + "src/files/Resume.38d60f3b6efff13a7b47b5d6595447c2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Resume.pdf
// module id = 89
// module chunks = 0